/**
 * Compares two strings using the locale-specific comparison algorithm.
 *
 * @param a - The first string to compare.
 * @param b - The second string to compare.
 * @returns A negative number if `a` is less than `b`, a positive number if `a` is greater than `b`, or 0 if they are equal.
 */
export const compareStrings = (a: string, b: string) => a.localeCompare(b);
